var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 318,
    viewBox: "0 0 230 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1224_6660)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 318,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 245,
    r: 4.5,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184 97C186 97 191 89.866 191 86C191 82.134 187.866 79 184 79C180.134 79 177 82.134 177 86C177 89.866 182 97 184 97ZM184 88C185.105 88 186 87.1046 186 86C186 84.8954 185.105 84 184 84C182.895 84 182 84.8954 182 86C182 87.1046 182.895 88 184 88Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 10,
    width: 68,
    height: 51,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 10,
    width: 41,
    height: 51,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 96,
    height: 51,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 142,
    width: 41,
    height: 51,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 267,
    width: 68,
    height: 51,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 67,
    width: 68,
    height: 51,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 67,
    width: 48,
    height: 20,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 130,
    width: 26,
    height: 27,
    rx: 13,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 118H11V173V186V214H107V173H55V118Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 142,
    width: 68,
    height: 51,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 200,
    width: 68,
    height: 51,
    fill: "#EAEAEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1224_6660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 318,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewMap);
export default __webpack_public_path__ + "static/media/preview-map.eedcb72410816c3c6409c91c88884f06.svg";
export { ForwardRef as ReactComponent };